import React, { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

interface Props {
  className?: string;
  absolute?: boolean;
}

export const LoadingOverlay: FC<Props> = (props) => {
  return (
    <Container data-test="loading-overlay" className={props?.className} absolute={props?.absolute}>
      <Spinner animation="border" />
      {props.children}
    </Container>
  );
};

const Container = styled.div<{ absolute?: boolean }>`
  width: 100%;
  text-align: center;
  padding-top: 2em;
  transition: background 300ms linear, opacity 300ms linear;

  overflow: hidden;
  /* FIXME fix colors when design system in place */
  background: ${(props) => (props.absolute ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.01)')};

  ${(props) =>
    props.absolute
      ? `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
  `
      : `
    position: relative;
    padding-top: 2em;
    padding-bottom: 2em;
    max-height: calc(100% - 2em);
  `}
`;
